import { useState } from 'react';

import dayjs, { extend } from 'dayjs';
import utc from 'dayjs/plugin/utc';

extend(utc);

type DateValueState = 'before' | 'after' | 'empty';
type Errors = Record<string, string>;

interface UseErrorsProps {
    fieldNames: string[];
}

export function handleValueValidation(event) {
    const { value, min, max, type } = event.target;
    const numValue = Number(value);
    const numMin = Number(min);
    const numMax = Number(max);

    if (!value || value?.length < 1 || value === 0) {
        return 'This field is required';
    }

    if (type === 'number') {
        if (numMin && numValue < numMin) {
            return `Value cannot be less than ${numMin}`;
        }
        if (numMax && numValue > numMax) {
            return `Value cannot be greater than ${numMax}`;
        }
    }
}

export function handleDateValidation(event) {
    const { value, min, max } = event.target;
    const dateValue = dayjs(value).utc();
    const valueState: DateValueState | undefined = !value
        ? 'empty'
        : dateValue.isBefore(min)
          ? 'before'
          : dateValue.isAfter(max)
            ? 'after'
            : undefined;

    switch (valueState) {
        case 'before': {
            return `Please select a date/time after ${min}`;
        }
        case 'after': {
            return `Please select a date/time before ${max}`;
        }
        case 'empty':
            return 'Please set a date';
        default: {
            return undefined;
        }
    }
}

export function useFormErrors({ fieldNames }: UseErrorsProps) {
    const initial = Object.fromEntries(fieldNames.map((n) => [n, '']));
    const [formErrors, setFormErrors] = useState<Errors>(initial);

    function handleError(fieldName, error) {
        setFormErrors((curr) => ({ ...curr, [fieldName]: error }));
    }

    return { formErrors, handleError };
}
